import React from 'react';
import { User, Settings, HelpCircle, LogOut } from 'lucide-react';
import { Link } from 'react-router-dom';
interface AvatarMenuProps {
  isOpen: boolean;
  onClose: () => void;
  userInitials: string;
  personaColor?: string;
}
export function AvatarMenu({
  isOpen,
  onClose,
  userInitials,
  personaColor = 'bg-gray-200 text-gray-600 border-gray-300'
}: AvatarMenuProps) {
  if (!isOpen) return null;
  return <div data-testid="avatar-menu" className="absolute top-full right-0 mt-2 w-56 bg-white border border-gray-300 shadow-lg z-50 rounded-sm" data-id="element-165">
      <div data-testid="avatar-menu-profile-section" className="p-4 border-b border-gray-100" data-id="element-166">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm border mb-2 ${personaColor}`} data-id="element-167">
          {userInitials}
        </div>
        <div data-testid="avatar-menu-username" className="font-bold text-sm text-[#1f2933]" data-id="element-168">
          User Profile
        </div>
        <div data-testid="avatar-menu-email" className="text-xs text-gray-500" data-id="element-169">
          user@example.com
        </div>
      </div>

      <div data-testid="avatar-menu-links" className="py-1" data-id="element-170">
        <Link data-testid="avatar-menu-profile-link" to="/profile" className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-171">
          <User className="w-4 h-4 text-gray-400" data-id="element-172" /> View Profile
        </Link>
        <Link data-testid="avatar-menu-settings-link" to="/settings" className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-173">
          <Settings className="w-4 h-4 text-gray-400" data-id="element-174" /> Account Settings
        </Link>
        <Link data-testid="avatar-menu-help-link" to="/help" className="flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-175">
          <HelpCircle className="w-4 h-4 text-gray-400" data-id="element-176" /> Help & Support
        </Link>
      </div>

      <div className="border-t border-gray-100 py-1" data-id="element-177">
        <button data-testid="avatar-menu-signout-btn" className="flex items-center gap-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50 w-full text-left font-medium" data-id="element-178">
          <LogOut className="w-4 h-4" data-id="element-179" /> Sign Out
        </button>
      </div>
    </div>;
}